import type { Theme } from '../../types/theme';

export const nvidiaTheme: Theme = {
  id: 'nvidia',
  name: 'NVIDIA',
  description: 'Engineering-grade marketing with NVIDIA Green accent and angular design',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/nvidia/DESIGN.md',
  visualKeywords: ['engineering', 'angular', 'green accent', 'bold typography', 'technical'],
  colors: {
    background: '#ffffff',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#000000',
    textSecondary: '#757575',
    textMuted: '#757575',
    border: '#cccccc',
    borderSubtle: '#c2c2c2',
    primary: '#76b900',
    primaryHover: '#85c80f',
    primaryActive: '#589b00',
    accent: '#76b900',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'technical',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
